import React from 'react';
import { DelayedMountAndUnmount } from 'libs/DelayedMount';
import { Banner, TextButton } from '@wikifactory/voxel-ui';
import { observer } from 'mobx-react';
import { SyncRepoAppManager } from '../appManager';

type LocalDriveBannerProps = {
  syncRepoAppManager: SyncRepoAppManager;
};

export const LocalDriveBanner = observer(
  ({ syncRepoAppManager }: LocalDriveBannerProps) => {
    let banner = null;
    if (syncRepoAppManager.syncingBlobs) {
      banner = (
        <Banner
          key='syncingBanner'
          variant='info'
          text='Downloading and updating local files...'
        />
      );
    } else if (syncRepoAppManager.pullingOrSyncingBlobs) {
      banner = (
        <Banner
          key='pullingBanner'
          variant='info'
          text='Syncing latest cloud contributions...'
        />
      );
    } else {
      banner = syncRepoAppManager.areThereNewRemoteCommits ? (
        <Banner key='pullBanner' variant='warning'>
          <div className='flex flex-row items-center text-black'>
            <div className='mr-1'>
              Your local drive is missing some contributions from the cloud
              drive:
            </div>
            <TextButton
              text='Sync now'
              onClick={() => {
                syncRepoAppManager.PullAndSync(true);
              }}
              // icon='download'
              // iconPosition='right'
            />
            <div className='mx-1'>or</div>
            <TextButton
              text='Open Cloud Drive in Browser'
              onClick={() => {
                syncRepoAppManager.openRepoInBrowser();
              }}
              // icon='external'
              // iconPosition='right'
            />
          </div>
        </Banner>
      ) : null;
    }

    if (!banner) {
      const numFailedDownloads = syncRepoAppManager.localSyncErrors.length;
      const areThereFailedDownloads = numFailedDownloads > 0;
      if (areThereFailedDownloads && !syncRepoAppManager.syncingBlobs) {
        banner = (
          <Banner key='syncFailed' variant='warning'>
            <div className='flex flex-row items-center text-black'>
              <div className='mr-2'>
                {numFailedDownloads} files failed to download.
              </div>
              <TextButton
                text='Try again'
                onClick={() => {
                  syncRepoAppManager.SyncBlobs();
                }}
                //   icon='download'
                //   iconPosition='right'
              />
            </div>
          </Banner>
        );
      }
    }
    return <DelayedMountAndUnmount>{banner}</DelayedMountAndUnmount>;
  },
);
